export var TriggerRecipientsTypeEnum;
(function (TriggerRecipientsTypeEnum) {
    TriggerRecipientsTypeEnum["SUBSCRIBER"] = "Subscriber";
    TriggerRecipientsTypeEnum["TOPIC"] = "Topic";
})(TriggerRecipientsTypeEnum || (TriggerRecipientsTypeEnum = {}));
